module.exports = __webpack_public_path__ + "static/media/profileNavLogoNew.a8dfe8cd.svg";